module.exports = __webpack_public_path__ + "img/X.78505275.svg";